import { render, staticRenderFns } from "./productCompany.vue?vue&type=template&id=2cfc3438&scoped=true&"
import script from "./productCompany.vue?vue&type=script&lang=js&"
export * from "./productCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc3438",
  null
  
)

export default component.exports